import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { markdownSx } from "./markdownStyles";

interface StreamingMessageProps {
  content: string;
}

export function StreamingMessage({ content }: StreamingMessageProps) {
  return (
    <Box sx={{ mb: 2, px: 2 }}>
      {/* Avatar + name row */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.75 }}>
        <Avatar
          sx={{
            width: 28,
            height: 28,
            bgcolor: "primary.main",
            fontSize: "0.85rem",
          }}
        >
          <SmartToyOutlinedIcon sx={{ fontSize: 18 }} />
        </Avatar>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: "text.primary"
          }}>
          Sales Coach
        </Typography>
      </Box>
      {/* Message bubble */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          maxWidth: "75%",
          bgcolor: "grey.100",
          borderRadius: 2,
          ml: 4.5,
        }}
      >
        <Box sx={{ wordBreak: "break-word", ...markdownSx }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </Box>
        <Box
          component="span"
          sx={{
            display: "inline-block",
            width: 8,
            height: 16,
            bgcolor: "text.secondary",
            ml: 0.5,
            animation: "blink 1s step-end infinite",
            "@keyframes blink": {
              "0%, 100%": { opacity: 1 },
              "50%": { opacity: 0 },
            },
          }}
        />
      </Paper>
    </Box>
  );
}
